import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getGameTypeSetting } from '../../services'
import { GameTypeSettingQueryKeys } from '@/modules/client-setting/keys'
import { GetGameTypeSettingResponse } from '@/modules/client-setting/type'

export default function useQueryGetGameTypeSetting(
	props?: UseBaseQueryOptions<GetGameTypeSettingResponse>,
) {
	return useQuery({
		queryKey: [GameTypeSettingQueryKeys.GetGameTypeSetting],
		queryFn: () => getGameTypeSetting(),
		...props,
	})
}
